// import { HiOutlineHashtag, HiOutlineHome, HiOutlinePhotograph, HiOutlineUserGroup } from 'react-icons/hi';

export const genres = [
  { title: "🔥   English Hits...", value: "English"},
  { title: "❤️‍🔥   BTS...",  value: "bts"},
  { title: "♥️   Love...",  value: "love"},
  { title: "⭐   Popular...", value: "Popular"},
  { title: "🎻   Hindi Hits...", value: "Hindi" },
  { title: "🤘   Rock...", value: "AP " },
  { title: "🫧   Feelz...", value: "Imran" },
  { title: "🌊   Sad...", value: "Atif" },
  { title: "🎉   Pop...", value: "Pop" },
  { title: "🔊   Hip-Hop...", value: "Hip" },
  { title: "🪩   Dance...", value: "Dance" },
  { title: "✌️   Soul...", value: "Soul" },
  { title: "☮️   Focus...", value: "Focus" },
  { title: "📽️   Film...", value: "Film" },
  { title: "🏠   House...", value: "House" },
];

export const albumIds = [
  '0Rkv5iqjF2uenfL0OVB8hg',
  '3uuu6u13U0KeVQsZ3CZKK4',
  '1HeX4SmCFW4EPHQDvHgrVS',
  '5xjaz957o6YGSXmlfd2tex',
  '4yP0hdKOZPNshxUOjY0cZj',
  '2RksiqpjjJUri0aO3sfe79',
  '0cm9LOQUBK3JUgyoRj238z',
  '7oiJYvEJHsmYtrgviAVIBD',
  '153Qw0xXJqhEFxvm9M9rE8',
  '3uuu6u13U0KeVQsZ3CZKK4',
  '5C4IT7eoAtWIfkDVvmsq7o',
  '13t8iDyl1vkhPcO3Zl29a9',
  '7vuWNVdv7zSwgHJ7qx26O4',
  '6jk3ucx33D7CLURgcfVFOT',
  '6Cyp74Z8rscKnSCcTSlg9n',
]

export const artistIds = [
  '4IWBUUAFIplrNtaOHcJPRM',
  '2oSONSC9zQ4UonDKnLqksx',
  '4PULA4EFzYTrxYvOVlwpiQ',
  '5NHm4TU5Twz7owibYxJfFU',
  '5r3wPya2PpeTTsXsGhQU8O',
  '0C8ZW7ezQVs4URX5aX7Kqx',
  '1McMsnEElThX1knmY4oliG',
  '4rTv3Ejc7hKMtmoBOK1B4T',
  '06HL4z0CvFAxyc27GXpf02',
  '1HnV8VaGdip3y1SpJPgft0',
  '4AK6F7OLvEQ5QYCBNiQWHq',
  '3Nrfpe0tUJi4K4DXYWgMUX',
  '5fuBZptKdXWB7NLT2eDwaT',
  '1Cs0zKBU1kc0i8ypK3B9ai',
  '5Pwc4xIPtQLFEnJriah9YJ',
]

export const sections = [
  {
    title: "🔥 Trending...",
    value: [
      "7sni37uwHitUkllYmcRO8W",
      "6pbaTBzAT23yL5xJxJfiFR",
      "15CyNDuGY5fsG0Hn9rjnpG",
      "6AJaDEafyyyWWXHZQtcFGe",
      "629ObWq3cm76kb3PNuVmZ8",
      "0xPcW40GWPqYki4y2Vi2pL",
      "30uPDcAcvwpfMV36F2BE2X",
      "44aCFqUbG06fL58kqpMp8p",
      "43iHptEDCmyn1WOQ40P7w4",
      "2ANhkyLkujmP1HbDrMCvfM",
      "0gX9tkL5njRax8ymWcXARi",
    ],
  },
  {
    title: "Punjabi Beats",
    value: [

    ]
  }
  
];

// export const links = [
//   { name: 'Discover', to: '/', icon: HiOutlineHome },
//   { name: 'Around You', to: '/around-you', icon: HiOutlinePhotograph },
//   { name: 'Top Artists', to: '/top-artists', icon: HiOutlineUserGroup },
//   { name: 'Top Charts', to: '/top-charts', icon: HiOutlineHashtag },
// ];

export const playlistIds = [
  "1yBsdsUwfFQOJWbvjyWxDc",
  "37i9dQZF1DWTYKFynxp6Fs",
  "4GbsZ1dxsKOPi9R7XOkkEk",
  "0Z7za9pQFEaGBVYTnvJMi1",
  "6dSz0AWxkgBfhlNBFyzqFf",
];